
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 64 64","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"V1_00000043423062483441023040000011390328541538303900_"}},[_c('path',{staticClass:"st0",attrs:{"d":"M32 16.1c14.8 0 26.7 13.2 26.7 15.9 0 2.6-12 15.9-26.7 15.9S5.3 34.4 5.3 32c0-2.5 11.9-15.9 26.7-15.9m0-4.9c-9.3 0-17 4.4-21.8 8-3.2 2.4-5.3 4.6-6.5 6.1C.8 28.7.5 30.7.5 32c0 1.3.4 3.2 3.2 6.6 1.2 1.5 3.4 3.7 6.5 6.1 4.8 3.7 12.5 8.1 21.8 8.1 4 0 8.1-.8 12.2-2.5 3.3-1.3 6.6-3.2 9.6-5.5 3.2-2.4 5.3-4.6 6.5-6.1 2.9-3.5 3.2-5.5 3.2-6.7 0-1.2-.3-3.3-3.2-6.7-1.2-1.5-3.4-3.7-6.5-6.1-3-2.3-6.3-4.1-9.6-5.5C40.1 12 36 11.2 32 11.2z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M32 22.7c5.2 0 9.4 4.2 9.4 9.4s-4.2 9.4-9.4 9.4-9.4-4.2-9.4-9.4 4.2-9.4 9.4-9.4m0-4.9c-7.9 0-14.3 6.4-14.3 14.3S24.1 46.3 32 46.3 46.3 40 46.3 32.1 39.9 17.8 32 17.8z"}}),_c('circle',{staticClass:"st0",attrs:{"cx":"32","cy":"32","r":"4.3"}})])])
          )
        }
      }
    